import styled from '../../../lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../mail.svg';

const ThemedMessages = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.icons,
        },
        '& path': {
            stroke: colors.icons,
        },
        '& polyline': {
            stroke: colors.icons,
        },
        '& line': {
            stroke: colors.icons,
        },
    };
});
const Messages: FC = ({ ...rest }) => {
    return <ThemedMessages {...rest} />;
};

export default Messages;
